/**
 * Скрипт, позволяющий использовать анимации animate.css из js.
 *
 * @module Animate
 */

$.fn.extend({
    /**
     * Применяет анимацию из списка animate.css.
     * Параметры анимации настраиваются внутри CSS для соответствующего класса (duration, timing-function, iteration-count и т.д.).
     *
     * @param {string} animationName Название анимации.
     * @param {Function} callback Функция, вызываемая по завершении анимации.
     * @return {jQuery} Изначальный объект для возможности чейнинга.
     *
     * @example
     * $('.element').animateCss('bounce');
     *
     * @example
     * $('.element').animateCss('bounce', function() {
     *     // Действия по завершении анимации
     * });
     *
     * @see Список возможных анимаций: {@link https://daneden.github.io/animate.css/}
     */
    animateCss(animationName, callback) {
        const animationEndEvents = 'animationend oAnimationEnd mozAnimationEnd webkitAnimationEnd';

        this.addClass(`animated ${animationName}`).one(animationEndEvents, () => {
            $(this).removeClass(`animated ${animationName}`);

            if (typeof callback === 'function') callback();
        });

        return this;
    },
});
